// extracted by mini-css-extract-plugin
export var container = "_3t-0";
export var error = "_3t-9";
export var label = "_3t-5";
export var light = "_3t-6";
export var md = "_3t-3";
export var sm = "_3t-2";
export var thin = "_3t-8";
export var thinBold = "_3t-7";
export var vertical = "_3t-4";
export var xs = "_3t-1";